import React, { useContext } from 'react';
import styled from 'styled-components';
import { TextField } from '@material-ui/core';

import { UserContext } from '../../../contexts/UserContext';

const Search = ({ onChange }) => {
  const { Site } = useContext(UserContext);
  const patronLabel = Site.siteType === 0 || Site.siteType === 5 ? 'students' : 'staff';
  return (
    <Input
      placeholder={`Search ${patronLabel}...`}
      onChange={onChange}
      autoFocus
    />
  );
};

const Input = styled(TextField)`
  margin-right: 1rem;
`;

export default Search;
